import { ReactNode, useRef, useState } from 'react';
import styles from './DialogNew.module.scss';

type DialogNewRender = (args: {
  open: () => void;
  close: () => void;
}) => ReactNode;

interface Props {
  children: DialogNewRender;
  content: DialogNewRender;
}

export function DialogNew({ children, content }: Props) {
  const ref = useRef<HTMLDialogElement | null>(null);
  const [opened, setOpened] = useState(false);

  const open = () => {
    ref.current?.showModal();
    setOpened(true);
  };

  const close = () => {
    ref.current?.close();
  };

  return (
    <>
      {children({ open, close })}
      <dialog ref={ref} className={styles['root']}>
        {opened && content({ open, close })}
      </dialog>
    </>
  );
}
